
// 在这个页面引入请求接口
import { alarmTracking, ImageGetURL } from '@/api/article'
const state = {
  logs: [],

  imageArr: [],
  result: null,
  resultShow: true
}
// 在这里加入报警跟踪的请求
const mutations = {
// 在mutations中写入同步代码
  FINDTRACK(state, [result, imageArr]) {
    state.result = result
    state.imageArr = imageArr
    if (result !== null) {
      state.resultShow = false
    }
    console.log(state.imageArr, result, imageArr, 'vuex中的数据 代表异步数据成功了')
  },

  ADD_ERROR_LOG: (state, log) => {
    state.logs.push(log)
  },
  CLEAR_ERROR_LOG: (state) => {
    state.logs.splice(0)
  }
}

const actions = {
  // 在这里写入异步请求

  async findTrack({
    commit
  }, id) {

    const {
      data: result,
      code
    } = await alarmTracking(this.getters.token, id)

    const imageArr = []
    if (code !== 200) {
      commit('FINDTRACK', [result, imageArr])
      return false
    }
    if (code === 200) {
      const images = result.IMAGES

      for (var i = 0; i < images.length; i++) {
        const imageUrl = await ImageGetURL(this.getters.token, images[i])
        console.log(code, result, imageUrl , images[i])

        // const imgArr = imageUrl.data.split('.com')[1]
        // const newUrl = 'http://img.lituo119.com/'
        // const protoImg = newUrl + imgArr
        const protoImg= this.$formatOssImageUrl(imageUrl.data)
        imageArr.push(protoImg)
      }
      commit('FINDTRACK', [result, imageArr])
    }
  },
  addErrorLog({ commit }, log) {
    commit('ADD_ERROR_LOG', log)
  },
  clearErrorLog({ commit }) {
    commit('CLEAR_ERROR_LOG')
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
